// inlined SVG icons
import Pig from "@/icons/pig.svg?react";
import Rabbit from "@/icons/rabbit.svg?react";
import React from "react";

// map of placeholders and their corresponding components
const placeholders: {[key: string]: {component: string}} = {
  PIG: {component: "Pig"},
  RABBIT: {component: "Rabbit"},
  BR: {component: "br"},
  NBSP: {component: "nbsp"},
  BS: {component: "boldStart"},
  BE: {component: "boldEnd"},
};

/**
 * Replace placeholders with components, e.g. ::PIG:: -> <Pig />
 */
export const sanitize = (text: string) => {
  let skipNextPart = false;

  // split text by placeholders and keep the placeholders in the array
  const parts = text.split(/::(.*?)::/g);

  // map parts to elements and replace placeholders with components
  const elements = parts.map((part, index) => {
    const placeholder = placeholders[part];

    // if placeholder exists, return the corresponding component
    if (placeholder) {
      const {component} = placeholder;

      switch (component) {
        case "br":
          return <br key={index} />;
        case "nbsp":
          return <span key={index}>&nbsp;</span>;
        case "Pig":
          return <Pig key={index} className="icon-sm fill-pig" />;
        case "Rabbit":
          return <Rabbit key={index} className="icon-sm fill-rabbit" />;
        case "boldStart":
          skipNextPart = true;
          return (
            <span key={index} className="font-bold">
              {parts[index + 1]}
            </span>
          );
        case "boldEnd":
        default:
          return null;
      }
      // if part is not a placeholder, return the part as is
    } else {
      // skip the part if the previous part was a placeholder
      // this is to handle the case where a placeholder is followed by text
      // e.g. ::BS::Hello::BE:: -> <span className="font-bold">Hello</span>
      if (skipNextPart) {
        skipNextPart = false;
        return null;
      }

      return <span key={index}>{part}</span>;
    }
  });

  return elements as React.ReactElement[];
};
